var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('h2', {
    attrs: {
      "id": "学习指南"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#学习指南"
    }
  }, [_vm._v("#")]), _vm._v(" 学习指南")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://gobyexample.com",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Go by Example"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/gobyexample-cn/gobyexample",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Go by Example 中文"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://books.studygolang.com/gopl-zh/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Go语言圣经（中文版）"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/chai2010/advanced-go-programming-book",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Go语言高级编程"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/Unknwon/go-fundamental-programming",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Go 编程基础"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/hyper0x/go_command_tutorial",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Go 命令教程"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://gfw.go101.org/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Go语言101"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/tmrts/go-patterns",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Go 设计模式"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/astaxie/build-web-application-with-golang",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Golang 构建web应用"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/smallnest/rpcx-programming-guide-cn",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("RPC开发指南 [中文文档]"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/mohuishou/go-design-pattern",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("go 设计模式实现"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/bingohuang/effective-go-zh-en",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("effective-go"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/LearnGolang/LearnGolang/tree/master?tab=readme-ov-file",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Golang学习资源大全"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/halfrost/LeetCode-Go",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("LeetCode 题解 go 语言版"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/jobbole/awesome-go-cn",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Go 资源大全中文版"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/avelino/awesome-go",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Go 资源大全"), _c('OutboundLink')], 1)])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "学习-demo"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#学习-demo"
    }
  }, [_vm._v("#")]), _vm._v(" 学习 demo")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/fengjx/go-web-quickstart",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("go-web-quickstart"), _c('OutboundLink')], 1), _vm._v(" go web 开发脚手架")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/fengjx/go-kit-start",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("go-kit-start"), _c('OutboundLink')], 1), _vm._v(" go-kit 项目脚手架")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/fengjx/go-kit-demo",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("go-kit-demo"), _c('OutboundLink')], 1), _vm._v(" go-kit 学习 demo")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "常用开源库"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#常用开源库"
    }
  }, [_vm._v("#")]), _vm._v(" 常用开源库")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/darjun/go-daily-lib",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("go 每日一库"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "spf13/viper",
      "desc": "配置文件解析，支持多种格式"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "json-iterator/go",
      "desc": "高性能json库"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "go-resty/resty",
      "desc": "http 客户端"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "redis/go-redis",
      "desc": "redis 客户端"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "asaskevich/EventBus",
      "desc": "轻量级 eventbus"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "panjf2000/ants",
      "desc": "高性能协程池"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "robfig/cron",
      "desc": "cron定时任务"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "petermattis/goid",
      "desc": "获取goroutine id"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "huandu/go-sqlbuilder",
      "desc": "一个sql builder库"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "doug-martin/goqu",
      "desc": "一个sql builder库"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "samber/lo",
      "desc": "类似lodash的集合操作工具库"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "gookit/cache",
      "desc": "通用的缓存管理"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "gookit/goutil",
      "desc": "一些常用的工具函数"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "gookit/color",
      "desc": "控制台颜色渲染工具库"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "fatih/color",
      "desc": "控制台颜色渲染工具库"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "duke-git/lancet",
      "desc": "一些常用的工具函数"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "Knetic/govaluate",
      "desc": "一个表达式解析库"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "PuerkitoBio/goquery",
      "desc": "类似jQuery的html解析"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "go-playground/validator",
      "desc": "参数校验工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "urfave/cli",
      "desc": "命令行参数解析"
    }
  })], 1)], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "测试"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#测试"
    }
  }, [_vm._v("#")]), _vm._v(" 测试")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "DATA-DOG/go-sqlmock",
      "desc": "sql mock 测试工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "golangci/golangci-lint",
      "desc": "lint 检查工具"
    }
  })], 1)], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "流行框架"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#流行框架"
    }
  }, [_vm._v("#")]), _vm._v(" 流行框架")]), _vm._v(" "), _c('ul', [_c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "gin-gonic/gin",
      "desc": "流行的web框架之一"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "labstack/echo",
      "desc": "流行的web框架之一"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "valyala/fasthttp",
      "desc": "流行的web框架之一"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "go-chi/chi",
      "desc": "流行的web框架之一"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "douyu/jupiter",
      "desc": "斗鱼开源的微服务框架"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "go-micro/go-micro",
      "desc": "微服务框架"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "zeromicro/go-zero",
      "desc": "微服务框架，支持代码生成工具"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('ClientOnly', [_c('github', {
    attrs: {
      "repo": "go-kit/kit",
      "desc": "微服务工具套件"
    }
  })], 1)], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };